import { render, staticRenderFns } from "./materialcircle.vue?vue&type=template&id=275386c7&scoped=true"
import script from "./materialcircle.vue?vue&type=script&lang=ts"
export * from "./materialcircle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275386c7",
  null
  
)

export default component.exports